import React from 'react';

// A-ADS (Anonymous Ads) adaptive banner, ad unit 2449843 — the same unit used
// on the wheel and tanks games. Shown above each info/content section on the
// homepage. Two tweaks vs. the stock A-ADS snippet: the z-index of 99998 is
// lowered so site popups/overlays still cover the ad, and the iframe is capped
// at 970px (the widest standard banner) so it stays full-width on phones but
// doesn't stretch absurdly on wide desktop layouts.
const AAdsBanner = () => (
  <div
    style={{
      width: '100%',
      margin: '24px auto',
      position: 'relative',
      zIndex: 10,
    }}
  >
    <iframe
      title="A-ADS advertisement"
      data-aa="2449843"
      src="//acceptable.a-ads.com/2449843/?size=Adaptive"
      style={{
        border: 0,
        padding: 0,
        width: '100%',
        maxWidth: '970px',
        height: 'auto',
        overflow: 'hidden',
        display: 'block',
        margin: 'auto',
      }}
    ></iframe>
  </div>
);

export default AAdsBanner;
